export const Platform = {
  OS: "web" as const,
  select<T>(specifics: { web?: T; default?: T; ios?: T; android?: T; native?: T }): T | undefined {
    return specifics.web ?? specifics.default ?? specifics.native
  },
  Version: "web",
}
